import { serverTimestamp } from 'firebase/firestore';

export interface EmailData {
    to: string[];
    message: {
        subject: string;
        text?: string;
        html: string;
        attachments?: Array<{
            filename: string;
            path: string;
        }>;
    };
    companyName?: string;
    metadata?: any;
}

/**
 * Send email via PHP proxy for immediate delivery
 */
export const sendEmailViaFirestore = async (emailData: EmailData): Promise<void> => {
    try {
        const emailUrl = process.env.REACT_APP_EMAIL_ENDPOINT || 'https://guarding.dynamixzone.com/api/send-email.php';

        if (!emailUrl) {
            throw new Error('Email endpoint not configured');
        }

        const response = await fetch(emailUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                to: emailData.to,
                subject: emailData.message.subject,
                html: emailData.message.html,
                companyName: emailData.companyName || 'Guard CRM',
                attachments: emailData.message.attachments
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to send email');
        }
    } catch (error: any) {
        console.error('Error sending email:', error);
        throw new Error(error.message || 'Failed to send email. Please try again later.');
    }
};
